import { render, staticRenderFns } from "./ShopTagSelector.vue?vue&type=template&id=3b1395a8&scoped=true"
import script from "./ShopTagSelector.vue?vue&type=script&lang=js"
export * from "./ShopTagSelector.vue?vue&type=script&lang=js"
import style0 from "./ShopTagSelector.vue?vue&type=style&index=0&id=3b1395a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1395a8",
  null
  
)

export default component.exports